
export enum NonWorkDayTypeCd {
	HOLIDAY = 'Holiday',
	PN_D_PARTIAL_DAY = 'PnDPartialDay',
	SERVICE_EXEMPT_DAY = 'ServiceExemptDay',
	WEEKEND = 'Weekend'}
